import React from 'react';
import { TextField, Autocomplete, MenuItem } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import { useController } from 'hooks';
import { SelectorValue } from 'types/types';

type Properties<T extends FieldValues> = {
  control: Control<T, null>;
  name: FieldPath<T>;
  label: string;
  values: SelectorValue[];
  placeholder?: string;
};

export const MultiSelector = <T extends FieldValues>({ control, name, label, values, placeholder }: Properties<T>) => {
  const { field } = useController({ name, control });
  const { onChange } = field;

  return (
    <Autocomplete
      sx={{ m: 1, width: '100%' }}
      multiple
      options={values}
      getOptionLabel={(option) => option.label}
      disableCloseOnSelect
      onChange={(_, values) => onChange(values)}
      renderInput={(params) => <TextField {...params} variant='outlined' label={label} placeholder={placeholder} />}
      renderOption={(props, { id, label }, { selected }) => (
        <MenuItem {...props} key={id} value={label} sx={{ justifyContent: 'space-between' }}>
          {label}
          {selected ? <CheckIcon color='info' /> : null}
        </MenuItem>
      )}
    />
  );
};
